import script from "./CookiesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiesComponent.vue?vue&type=script&setup=true&lang=js"

import "./CookiesComponent.vue?vue&type=style&index=0&id=af72e2a0&lang=css"

const __exports__ = script;

export default __exports__